import { useEffect, useState } from "react";
import {useSelector} from "react-redux";

export const useProfile = () => {
  const reduxUser = useSelector(state => state.Login.user);
  const [userProfile, setUserProfile] = useState(reduxUser);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (reduxUser) {
      setUserProfile(reduxUser);
    } else {
      const savedUser = localStorage.getItem("user");
      if (savedUser) {
        setUserProfile(JSON.parse(savedUser));
      }
    }
    setLoading(false);
  }, [reduxUser]);

  return { userProfile, loading };
};